import { Box } from '@mui/material'
import MiniChart from '@/components/Table/MiniChart'
import CrmStatus from '@/components/Table/CrmStatus'
import { CustomColumnGridConfig } from '../types'
import MeterLink from '@/components/Table/MeterLink'

// const iconMap: Record<string, { icon: string; alt: string }> = {
//   EmailIcon: {
//     icon: EmailIcon,
//     alt: 'Email',
//   },
//   WhatsappIcon: {
//     icon: WhatsappIcon,
//     alt: 'Whatsapp',
//   },
//   SmsIcon: {
//     icon: SmsIcon,
//     alt: 'Sms',
//   },
//   FileIcon: {
//     icon: FileIcon,
//     alt: 'letter',
//   },
// }

export const CONSUMPTION_FIELD = 'consumption' as const

const columnsConfig: CustomColumnGridConfig[] = [
  {
    field: 'meterNumber',
    headerName: 'מספר מונה',
    hideable: true,
    width: 150,
    minWidth: 150,
    flex: 1,
    renderCell: (params: any) => {
      if (params.value == null) return '-'
      return <MeterLink meter={params.value} />
    },
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    field: 'name',
    headerName: 'שם הצרכן',
    hideable: true,
    disableAggregation: true,
    width: 150,
    minWidth: 150,
    flex: 1,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    field: 'waterCard',
    minWidth: 150,
    flex: 1,
    headerName: 'כרטיס מים',
    hideable: true,
    disableAggregation: true,
    width: 150,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    minWidth: 150,
    flex: 1,
    field: 'address',
    headerName: 'כתובת',
    hideable: true,
    disableAggregation: true,
    width: 150,
    filter: {
      type: 'search',
    },
    filterable: true,
  },
  {
    minWidth: 150,
    flex: 1,
    width: 150,
    field: 'dailyUsageData',
    headerName: 'צ. אחרונות',
    renderCell: (params: any) => {
      if (params.value == null) return '-'
      return (
        <Box
          sx={{
            width: '100%',
            height: '90%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
          }}
        >
          <MiniChart data={params.value} />
        </Box>
      )
    },
    filter: {
      type: 'none',
    },
    disableAggregation: true,
    hideable: true,
  },
  {
    minWidth: 150,
    flex: 1,
    width: 150,
    field: 'rValue',
    headerName: 'ערך R',
    type: 'number',
    aggregable: true,
    hideable: true,
    renderCell: (params: any) => {
      return <div>{params && params.value ? params.value : '0'}</div>
    },
    filter: {
      type: 'aggregated',
    },
    filterable: true,
  },
  {
    minWidth: 150,
    flex: 1,
    width: 150,
    field: 'openAlerts',
    headerName: 'התראות',
    type: 'number',
    aggregable: false,
    hideable: true,
    renderCell: (params: any) => {
      if (params.value) {
        return (
          <Box
            sx={{
              display: 'flex',
              height: 'fit-content',
              gap: 1,
              overflowY: 'auto',
            }}
          >
            {params.value.map((alert: any, index: number) => {
              return (
                <div key={index}>
                  {alert.name} {index + 1 !== params.value.length && <span>,</span>}
                </div>
              )
            })}
          </Box>
        )
      } else {
        return <div>-</div>
      }
    },
    filter: {
      type: 'options',
    },
    filterable: true,
  },
  {
    minWidth: 150,
    flex: 1,
    width: 250,
    field: 'lastSeen',
    headerName: 'נקלט לאחרונה',
    hideable: true,
    sortComparator: (v1, v2) => {
      const parseDate = (val: string) => {
        if (!val) return 0
        const [year, month, day] = val.split('T')[0].split('-').map(Number)
        return new Date(year, month - 1, day, 0, 0, 0, 0).getTime()
      }
      return parseDate(v1) - parseDate(v2)
    },
    disableAggregation: true,
    filter: {
      type: 'date',
    },
    filterable: true,
  },
  {
    minWidth: 150,
    flex: 1,
    width: 150,
    field: 'diameter',
    headerName: 'קוטר',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
  },
  {
    minWidth: 150,
    width: 150,
    field: 'propertyNumber',
    headerName: 'מספר נכס',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },

  {
    minWidth: 150,
    width: 150,
    field: 'tenantCount',
    headerName: 'מספר נפשות',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
  },

  {
    minWidth: 150,
    width: 150,
    field: 'area',
    headerName: 'אזור',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
  },

  {
    minWidth: 150,
    width: 150,
    field: 'parentCard',
    headerName: 'כרטיס אב',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },

  {
    minWidth: 150,
    width: 150,
    field: 'isSiteMain',
    headerName: 'אתר ראשי',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
    renderCell: (params: any) => {
      return params.value ? 'כן' : 'לא'
    },
  },
  {
    minWidth: 150,
    width: 150,
    field: 'payerNumber',
    headerName: 'מספר משלם',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
  },

  {
    minWidth: 150,
    width: 150,
    field: 'phone',
    headerName: 'מספר טלפון',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
    renderCell: (params: any) => {
      const value = params.value
      if (!value) return '-'
      
      // Handle array of phone numbers
      if (Array.isArray(value)) {
        if (value.length === 0) return '-'
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            {value.map((phone: string, index: number) => (
              <span key={index}>{phone}</span>
            ))}
          </div>
        )
      }
      
      // Handle string (single phone or comma-separated)
      if (typeof value === 'string') {
        if (value.includes(',')) {
          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {value.split(',').map((phone: string, index: number) => (
                <span key={index}>{phone.trim()}</span>
              ))}
            </div>
          )
        }
        return value
      }
      
      if (typeof value === 'number') return value.toString()
      return '-'
    },
  },
  {
    minWidth: 200,
    width: 200,
    flex: 1,
    field: 'email',
    headerName: 'אימייל',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'search',
    },
    filterable: true,
    renderCell: (params: any) => {
      const value = params.value
      if (!value) return '-'
      
      // Handle array of emails
      if (Array.isArray(value)) {
        if (value.length === 0) return '-'
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            {value.map((email: string, index: number) => (
              <span key={index}>{email}</span>
            ))}
          </div>
        )
      }
      
      // Handle string (single email or comma-separated)
      if (typeof value === 'string') {
        if (value.includes(',')) {
          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {value.split(',').map((email: string, index: number) => (
                <span key={index}>{email.trim()}</span>
              ))}
            </div>
          )
        }
        return value
      }
      
      return '-'
    },
  },
  {
    minWidth: 150,
    field: 'crm',
    headerName: 'crm',
    flex: 1,
    width: 150,
    renderCell: (params: any) => {
      return params.value ? <CrmStatus value={params.value} /> : '-'
    },
    filter: {
      type: 'options',
    },
    hideable: true,
    disableAggregation: true,
    filterable: true,
  },
  {
    minWidth: 120,
    width: 120,
    field: 'usageType',
    headerName: 'סוג שימוש',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
  },
  {
    minWidth: 120,
    width: 120,
    field: 'meterModelName',
    headerName: 'דגם מונה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
  },
  {
    minWidth: 150,
    width: 150,
    field: 'amrIsActive',
    headerName: 'האם מחובר לקר"מ',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
    renderCell: (params: any) => {
      return params.value ? 'כן' : 'לא'
    },
  },
  {
    minWidth: 180,
    width: 180,
    field: 'amrSystemKey',
    headerName: 'לאיזה שרת קריאות מתחבר',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'options',
    },
    filterable: true,
  },
  {
    minWidth: 150,
    width: 150,
    field: 'installedPeriod',
    headerName: 'תאריך התקנה',
    hideable: true,
    disableAggregation: true,
    filter: {
      type: 'date',
    },
    filterable: true,
  },

  // {
  //   field: 'sent',
  //   headerName: 'נשלח',
  //   width: 150,
  //   filter: {
  //     type: 'none',
  //   },
  //   renderCell: (params: any) => {
  //     const channels: Array<{
  //       channel: string
  //       icon: string
  //     }> = params.row?.sentChannels ?? []

  //     if (channels.length)
  //       return (
  //         <Box
  //           sx={{
  //             display: 'flex',
  //             alignItems: 'center',
  //             gap: 1,
  //             justifyContent: 'center',
  //             width: '100%',
  //           }}
  //         >
  //           {channels.map((channelObj, index) => (
  //             <Tooltip key={index} title={iconMap[channelObj.icon].alt}>
  //               <img
  //                 src={iconMap[channelObj.icon].icon}
  //                 alt={iconMap[channelObj.icon].alt}
  //                 style={{ width: 18, height: 18 }}
  //               />
  //             </Tooltip>
  //           ))}
  //         </Box>
  //       )
  //   },
  // },

  // {
  //   width: 150,
  //   field: 'payerNumber',
  //   headerName: 'מספר משלם',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: {
  //     type: 'search',
  //   },
  //   filterable: true,
  // },
  // {
  //   width: 150,
  //   field: 'contractNumber',
  //   headerName: 'מספר חוזה',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: {
  //     type: 'none',
  //   },
  // },
  // {
  //   width: 150,
  //   field: 'tenantCount',
  //   headerName: 'כמות דיירים',
  //   hideable: true,
  //   filter: { type: 'none' },
  // },
  // {
  //   width: 150,
  //   field: 'installDate',
  //   headerName: 'תאריך התקנה',
  //   hideable: true,
  //   sortComparator: (v1, v2) => {
  //     const parseDate = (val: string) => {
  //       if (!val) return 0
  //       const [day, month, year] = val.split('/').map(Number)
  //       return new Date(year, month - 1, day).getTime()
  //     }
  //     return parseDate(v1) - parseDate(v2)
  //   },
  //   disableAggregation: true,
  //   filter: {
  //     type: 'none',
  //   },
  //   filterable: true,
  // },
  // {
  //   field: 'parentCard',
  //   width: 150,
  //   headerName: 'כרטיס אב',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: {
  //     type: 'search',
  //   },
  // },
  // {
  //   field: 'area',
  //   width: 150,
  //   headerName: 'אזור',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: {
  //     type: 'options',
  //   },
  //   filterable: true,
  // },
  // {
  //   width: 150,
  //   field: 'phone',
  //   headerName: 'מספר טלפון',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: {
  //     type: 'search',
  //   },
  //   filterable: true,
  // },
  // {
  //   width: 150,
  //   field: 'email',
  //   headerName: 'אימייל',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: {
  //     type: 'search',
  //   },
  //   filterable: true,
  // },
  // {
  //   width: 150,
  //   field: 'branch',
  //   headerName: 'ענף',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: {
  //     type: 'none',
  //   },
  // },
  // {
  //   width: 150,
  //   field: 'issuer',
  //   headerName: 'יצרן מד',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: {
  //     type: 'options',
  //   },
  //   filterable: true,
  // },
  // {
  //   width: 150,
  //   field: 'openCycle',
  //   headerName: 'מעגל פתוח',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: {
  //     type: 'none',
  //   },
  //   filterable: true,
  // },
]

export default columnsConfig
